/* === SK Animations ===
   IntersectionObserver para animaciones de entrada al scroll
*/
(function() {
  'use strict';

  /* Secciones excluidas (above the fold) */
  var SKIP = ['sk-header', 'sk-hero', 'sk-about-hero', 'sk-breadcrumb'];

  /* Contenedores cuyos hijos se animan en stagger */
  var STAGGER = [
    '.sk-products__slider',
    '.sk-categories__grid',
    '.sk-values__cards',
    '.sk-quality__seals-track',
    '.sk-blog-posts__slider',
    '.sk-faq__accordion',
    '.sk-about-faq__accordion',
    '.sk-collection-grid__grid',
    '.sk-collection-subcats__grid',
    '.sk-recommended__slider',
    '.sk-about-gallery__track',
    '.sk-about-story__values-list',
    '.sk-about-product__features',
    '.sk-reviews__slider'
  ];

  function shouldSkip(el) {
    for (var i = 0; i < SKIP.length; i++) {
      if (el.classList.contains(SKIP[i])) return true;
    }
    return false;
  }

  function setup(el) {
    if (shouldSkip(el)) return null;
    el.classList.add('sk-animate');

    for (var i = 0; i < STAGGER.length; i++) {
      var c = el.querySelector(STAGGER[i]);
      if (c && c.children.length > 1) {
        c.classList.add('sk-stagger');
      }
    }
    return el;
  }

  function init() {
    var all = document.querySelectorAll('section[class*="sk-"]');
    var targets = [];

    for (var i = 0; i < all.length; i++) {
      var el = setup(all[i]);
      if (el) targets.push(el);
    }
    if (!targets.length) return;

    /* Fallback sin IntersectionObserver */
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('sk-animate--visible');
      }
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('sk-animate--visible');
          observer.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.08 });

    /* Secciones ya visibles al cargar: cascade con delay */
    var delay = 0;
    for (var i = 0; i < targets.length; i++) {
      var rect = targets[i].getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        (function(el, d) {
          setTimeout(function() { el.classList.add('sk-animate--visible'); }, d);
        })(targets[i], delay);
        delay += 150;
      } else {
        observer.observe(targets[i]);
      }
    }
  }

  /* Iniciar */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Customizer: mostrar seccion cargada inmediatamente */
  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('section[class*="sk-"]');
    if (s && !shouldSkip(s)) {
      setup(s);
      requestAnimationFrame(function() {
        s.classList.add('sk-animate--visible');
      });
    }
  });
})();
